import { useKeyPress } from '@smartproxy-web/shared/hooks';
import { useState } from 'react';

import Popover from '@/decodo/components/atoms/Popover';

import { targets } from './constants/targets';
import { ScraperHeaderCard } from './ScraperHeaderCard';
import { ScraperHeaderTargetOptions } from './ScraperHeaderTargetOptions';
import { useScraper } from './state/context';

export const ScraperHeader = () => {
  const { target, setTarget } = useScraper();

  const [open, setOpen] = useState(false);

  useKeyPress('Escape', () => setOpen(false));

  return (
    <header>
      <Popover
        classNames={{
          target: 'w-full group/popover',
          childrenWrapper:
            'w-full mt-2 p-0 py-3 shadow-popup-d border-gray-200 rounded',
        }}
        target={<ScraperHeaderCard />}
        showArrow={false}
        onChange={setOpen}
        isOpen={open}
        contentProps={{ avoidCollisions: false }}
      >
        <ScraperHeaderTargetOptions
          targets={targets}
          selectedTarget={target}
          handleTargetSelect={(newTarget) => {
            setTarget(newTarget);
            setOpen(false);
          }}
        />
      </Popover>
    </header>
  );
};
